function addListener(selector, event, handler) {
  for(const el of document.querySelectorAll(selector))
    el.addEventListener(event, handler)
}

function saveTheme(ev) {
  const theme = ev.target.value
  document.body.dataset.theme = window.localStorage.theme = theme
  restoreTheme()
}

function restoreTheme() {
  const { theme } = window.localStorage
  if(theme) {
    const el = document.getElementById(`theme-${theme}`)
    if (el) el.checked = true
  }
}

function setupMobileNav() {
  const mobileNavDetails = document.querySelector('.site-nav')
  if (!mobileNavDetails) return

  const summary = mobileNavDetails.querySelector('summary')
  const firstLink = mobileNavDetails.querySelector('a')
  let openedWithKeyboard = false
  let shouldRestoreFocus = false

  function usesCompactNav() {
    return getComputedStyle(summary).display !== 'none'
  }

  function syncExpandedState() {
    // aria-expanded is a string attribute, so stringify the boolean state.
    summary.setAttribute('aria-expanded', `${mobileNavDetails.open}`)
  }

  function closeMenu({ restoreFocus = false } = {}) {
    shouldRestoreFocus = restoreFocus
    mobileNavDetails.open = false
  }

  syncExpandedState()

  summary.addEventListener('pointerdown', () => {
    openedWithKeyboard = false
  })

  summary.addEventListener('keydown', e => {
    if (e.key === 'Enter' || e.key === ' ') {
      openedWithKeyboard = true
    }
  })

  mobileNavDetails.addEventListener('toggle', () => {
    syncExpandedState()

    if (!mobileNavDetails.open && shouldRestoreFocus) {
      summary.focus()
    }

    if (mobileNavDetails.open && openedWithKeyboard && usesCompactNav()) {
      firstLink?.focus()
    }

    if (!mobileNavDetails.open) {
      shouldRestoreFocus = false
    }

    openedWithKeyboard = false
  })

  mobileNavDetails.addEventListener('keydown', e => {
    if (e.key === 'Escape' && mobileNavDetails.open) {
      e.preventDefault()
      e.stopPropagation()
      closeMenu({ restoreFocus: true })
    }
  })

  document.addEventListener('click', e => {
    if (!usesCompactNav() || !mobileNavDetails.open || mobileNavDetails.contains(e.target)) {
      return
    }

    closeMenu({ restoreFocus: mobileNavDetails.contains(document.activeElement) })
  })

  addListener('.site-nav .primary-nav a', 'click', () => {
    if (usesCompactNav()) closeMenu()
  })

  addEventListener('resize', () => {
    if (!usesCompactNav()) closeMenu()
  })
}

addEventListener('DOMContentLoaded', () => {
  addListener('.theme-select input', 'change', saveTheme)
})

window.onstorage = restoreTheme

addEventListener('DOMContentLoaded', () => {
  restoreTheme()
  setupMobileNav()

  addListener('.theme-select input', 'change', saveTheme)

  // Close ToC when link is clicked or when click outside of it
  if (typeof ToC !== 'undefined') {
    document.addEventListener('click', e => {
      if (e.target.nodeName === 'A' || !ToC.contains(e.target)) {
        ToC.removeAttribute('open')
      }
    })
  }
})
addEventListener('pageshow', restoreTheme)

function getExtraPath() {
  return window.location.pathname.replace(new RegExp(`^${RegExp.escape(document.body.dataset.url)}`), '')
}
